import { jsx } from 'react/jsx-runtime';
import { Loader as y } from './contact-channels94.js';
import { CHAT_CONFIG as n } from './contact-channels102.js';
import { useTranslations as $ } from './contact-channels43.js';
import { useChat as G } from './contact-channels5.js';
import { FlexBox, Typography } from '@vp/swan';

const j=a=>{var i,s,r;const{showLoading:e=true,variation:t="minimal",customMessage:m}=a,{data:o,isLoading:c,isPending:p}=G(),{t:l}=$(),d=t==="minimal",f=l((r=(s=n[((i=o==null?void 0:o.plainData)==null?void 0:i.chatStatus)||"offline"])==null?void 0:s[t])==null?void 0:r.chatDescription);return jsx(y,{skeletonLines:d?2:1,isLoading:c||p,showLoading:e,children:jsx(FlexBox,{children:jsx(Typography,{component:"span",fontSize:"standard",children:m||f})})})};

export { j as ChatContent };
//# sourceMappingURL=contact-channels31.js.map
